import { useAccount } from 'wagmi';
import { useCallback } from 'react';
import { useConnectModal, useChainModal } from '@rainbow-me/rainbowkit';
export { RainbowKitProvider, connectorsForWallets, useAccountModal, useChainModal, useConnectModal } from '@rainbow-me/rainbowkit';

// src/hooks/useConnectWallet.ts
var useConnectWallet = () => {
  const account = useAccount();
  const { openConnectModal } = useConnectModal();
  const { openChainModal } = useChainModal();
  const connection = useCallback(
    (onConnected) => {
      if (!account.isConnected) {
        openConnectModal?.();
        return;
      }
      if (!account.chain) {
        openChainModal?.();
        return;
      }
      onConnected?.();
    },
    [account, openConnectModal, openChainModal]
  );
  const isConnected = account.isConnected;
  const isUnsupported = account.isConnected && !account.chain;
  return { isConnected, isUnsupported, connection };
};
function useWallet() {
  const account = useAccount();
  const { openConnectModal } = useConnectModal();
  const { openChainModal } = useChainModal();
  const ensureWalletReady = useCallback(() => {
    if (!account.isConnected) {
      openConnectModal?.();
      return false;
    }
    if (!account.chain) {
      openChainModal?.();
      return false;
    }
    return true;
  }, [account, openConnectModal, openChainModal]);
  return {
    isConnected: account.isConnected,
    ensureWalletReady
  };
}

export { useConnectWallet, useWallet };
